import { type App } from 'vue';
import { usePage }  from "@inertiajs/vue3";

type TypeProps = {
    translations? : {
        [key : string] : string
    },
    global_translations? : {
        [key : string] : string
    }
};

/**
 * @global
 * @function __
 * @param translate_name {string}
 */
export const __ = (translate_name : string) : string => {
    const page = usePage<TypeProps>().props,
        translations = (page?.translations ?? null),
        global_translations = (page?.global_translations ?? null);

    if (!translations && !global_translations) {
        return '';
    } else if (translations && typeof translations[translate_name] != 'undefined') {
        return translations[translate_name];
    } else if (global_translations && typeof global_translations[translate_name] != 'undefined') {
        return global_translations[translate_name];
    }

    return '';
};

export default {
    install(app : App) : void {
        app.config.globalProperties.__ = __;
    },
};
